<template>
    <div>
         <header id="home" class="container">  
            <div >

                <div class="close-menu display-none"></div>

                <nav class="nav">
    
                   
                    <div class="logo">
                    <img src="@/assets/logo.png" alt="logo">
                    </div>
              
                    <div class="nav-list-container">
                        <ul class="nav-list">
                            <li class="nav-item">
                                <a href="#home" class="nav-link active" >Home</a>
                            </li>
                            <li class="nav-item">
                                <a href="#about" class="nav-link">About</a>
                            </li>
                            <li class="nav-item">
                                <a href="#projects" class="nav-link">Projects</a>
                            </li>
                            <li class="nav-item">
                                <a href="#footer" class="nav-link">Contact</a>
                            </li>
                            <li class=" social-media-container">
                                <ul class="social-media">
                                        <li class="nav-item">
                                            <a href="https://www.instagram.com/asaphni/"> <img src="@/assets/instagram.svg" alt="" style="height: 1.5rem;"></a>
                                        </li>
                                        <li class="nav-item">
                                            <a href="https://twitter.com/nila52631977"> <img src="@/assets/twitter.svg" alt="" style="height: 1.5rem;"></a>
                                        </li>
                                        <li class="nav-item">
                                            <a href="https://www.facebook.com/niyera.assaf/"> <img src="@/assets/facebook.svg" alt="" style="height: 1.5rem;"></a>
                                        </li>
                                </ul>
                            </li>

                        </ul>
                    </div>
                    <div class="bout2">

                        <span class="span s1"></span>
                        <span class="span s2"></span>
                        <!-- <span class="span s3"></span> -->
                    </div>
                </nav>
            </div>

    </header>
    </div>
</template>
<script>
export default {
    
}
</script>
<style lang="css">
    
</style>